module.exports = __webpack_public_path__ + "static/media/17_potolok_3.96_0.31ecacde.png";